import React from "react";
import PropTypes from "prop-types";
import { capitalizeFirstLetter } from "../../../../utils/string-helpers";
import SvgIcon from "../../../../parts/SvgIcon";

const MasterFoodLibraryHeader = ({ section, updateState, search }) => {
  const urlBase = `/actions/refresh/?modal[type]=`;
  const finalUrl =
    section === "food"
      ? `${urlBase}handle-meal-planner-food`
      : `${urlBase}build-meal`;

  return (
    <div>
      <header className="header-master-food-library">
        <hgroup>
          <div className="title-container">
            <SvgIcon
              src="/img/new-icons/back-button.svg"
              onClickFn={() => {
                window.location.href = `${origin}/coaching-portal/all-templates?owner=coach&tabView=meal-plans-tab`;
              }}
              classNames="cursor-pointer"
            />
            <h3>Master Food Library</h3>
          </div>
          <p className="p4 opacity-70">
            Build and manage the master Food library for your account so you can
            build meal planner
          </p>
        </hgroup>
        <a role="button" data-button-type="primary" href={finalUrl}>
          <img src="/img/new-icons/add.svg" alt="Add New" />
          Add New {capitalizeFirstLetter(section)}
        </a>
      </header>
      <div className="options">
        <input
          type="search"
          name="search"
          placeholder={`Search ${capitalizeFirstLetter(section)}`}
          value={search}
          onChange={(e) => updateState({ search: e.target.value })}
          autoComplete="off"
          data-expandable
        />
        <button
          data-button-type={section === "food" ? "outline" : "secondary"}
          onClick={() => updateState({ section: "food" })}
        >
          <span>Food</span>
        </button>
        <button
          data-button-type={section === "meal" ? "outline" : "secondary"}
          onClick={() => updateState({ section: "meal" })}
        >
          <span>Meals</span>
        </button>
      </div>
    </div>
  );
};

MasterFoodLibraryHeader.propTypes = {
  section: PropTypes.string,
  search: PropTypes.string,
  updateState: PropTypes.func,
};

export default MasterFoodLibraryHeader;
